export default function AccordionSection({ title, id, children, openSection, onToggle }) {
    const isOpen = openSection === id;
    return (
        <div className="border border-gray-200 rounded-lg">
            <button
                type="button"
                className="w-full flex justify-between items-center p-4 text-left font-semibold text-gray-800 bg-gray-50 hover:bg-gray-100"
                onClick={() => onToggle(id)}
            >
                {title}
                <i className={`fas fa-chevron-down transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {isOpen && (<div className="p-4 space-y-4 bg-white">{children}</div>)}
        </div>
    );
}
